import React from 'react';

const MyPurchase = () => {
    return (
        <div>
            
        </div>
    );
};

export default MyPurchase;